export const types = {
  MANAGED_INTEGRATIONS_CREATE_OR_EDIT_DRAWER_OPEN:
    'common/drawers/createIntegrationDrawer/MANAGED_INTEGRATIONS_CREATE_OR_EDIT_DRAWER_OPEN',
  MANAGED_INTEGRATIONS_DRAWER_CREATE_OR_EDIT_CLOSE:
    'common/drawers/createIntegrationDrawer/MANAGED_INTEGRATIONS_CREATE_OR_EDIT_DRAWER_CLOSE',
  MANAGED_INTEGRATIONS_DRAWER_EDIT_INTEGRATION:
    'common/drawers/createIntegrationDrawer/MANAGED_INTEGRATIONS_DRAWER_EDIT_INTEGRATION',
  MANAGED_INTEGRATIONS_CREATE_SUCCESS:
    'common/drawers/createIntegrationDrawer/MANAGED_INTEGRATIONS_CREATE_SUCCESS',
};

export const managedIntegrationDrawer = {
  open: ({ isSuperUser = null }) => ({
    type: types.MANAGED_INTEGRATIONS_CREATE_OR_EDIT_DRAWER_OPEN,
    payload: {
      isSuperUser,
    },
  }),
  close: () => ({
    type: types.MANAGED_INTEGRATIONS_DRAWER_CREATE_OR_EDIT_CLOSE,
  }),
  edit: ({ managedIntegrationUuid }) => ({
    type: types.MANAGED_INTEGRATIONS_DRAWER_EDIT_INTEGRATION,
    payload: { managedIntegrationUuid },
  }),
  success: () => ({
    type: types.MANAGED_INTEGRATIONS_CREATE_SUCCESS,
  }),
};
